// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1TD9-","colMaxWidth":"Table_colMaxWidth__Nc8K5"};